export const PATHS = {
  ADMIN_USERS: '/admin-users',
  ALERTS: '/alerts',
  BOARD_BUILDER: '/board-builder',
  CORRELATIONS: '/correlations',
  GAME_MODES: '/game-modes',
  GAME_TYPES: '/game-types',
  LEAGUES: '/leagues',
  MEMBERS: '/members',
  MEMBER_GROUPS: '/member_groups',
  MISSIONS: '/missions',
  PAYMENTS: '/payments',
  PLAYER_PACKS: '/player-packs',
  PLAYERS: '/players',
  POLLS: '/polls',
  PROMOTION_APPROVALS: '/promotion-approvals',
  PROMOTIONS: '/promotions',
  RESOLUTIONS: '/resolutions',
  ROLES: '/roles',
  RULESETS: '/rulesets',
  SCORING: '/scoring',
  SIGN_IN: '/sign-in',
  SIMULATIONS: '/simulations',
  STAT_TYPE: '/stat-type',
  TEAMS: '/teams',
  ALLOWED_STATES: '/allowed-states',
  STREAK: '/streak',
  TRADING: '/trading',
  UNSETTLEMENTS: '/unsettlements'
};

export const SIMULATION_EXISTING_PATH = '/simulations/:leagueId/:gameId';
export const SIMULATION_DETAILS_PATH =
  '/simulations/:leagueId/:gameId/:simulationId';

export const MEMBER_DETAILS_PATH = '/members/:memberId';
export const MEMBER_SUPPORT_PATH = '/members/member-support/:uuid';

export const MEMBER_DETAILS_CHILD_PATHS = {
  profile: 'profile',
  entries: 'entries',
  deposits: 'deposits',
  referrals: 'referrals',
  withdrawals: 'withdrawals',
  responsibleGaming: 'responsible-gaming',
  promotions: 'promotions',
  notes: 'notes',
  transactions: 'transactions',
  polls: 'polls'
};

export const PROMOTIONS_CHILD_PATHS = {
  create: 'new',
  view: ':promotionId'
};

export const MISSIONS_CHILD_PATHS = {
  create: 'new',
  view: ':missionId'
};

export const PLAYER_PACKS_CHILD_PATHS = {
  create: 'new',
  view: ':playerPackId'
};

export const RESOLUTION_DETAILS_PATH = '/resolutions/:resolutionId';

export const UNSETTLEMENTS_CHILD_PATHS = {
  create: 'new'
};
